import { render, staticRenderFns } from "./TemplatesToEmailsTiers.vue?vue&type=template&id=97566be8&scoped=true"
import script from "./TemplatesToEmailsTiers.vue?vue&type=script&lang=js"
export * from "./TemplatesToEmailsTiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97566be8",
  null
  
)

export default component.exports